import { useContext } from "react";
import { APIErrorContext, IAPIErrorContext } from "../context/APIErrorProvider";

export const useAPIError = () => {
    const { error, addError, removeError } =
        useContext<IAPIErrorContext>(APIErrorContext);
    return { error, addError, removeError };
};
